/**
 * Layout tokens for the Documents sidebar tree, per the "Sidebar — row
 * states" artboard (cards 1.5 / 1.6): row 30 px, indent 18 px per level with a
 * 1 px guide line under each level. Colours live in DocumentsSidebar.css as
 * custom properties (dark is the design of record, light has equivalents).
 */

// Row left padding: 6 px at the top level, then 18 px per level (22, 40, 58…).
export const ROW_INDENT_TOP = 6;
export const ROW_INDENT_STEP = 18;
const ROW_INDENT_NESTED_BASE = 4;
// A level's guide line sits under its parent's chevron centre (13, 31, 49…).
const GUIDE_FIRST = 13;

export function rowIndent(depth) {
  return `${depth > 0 ? ROW_INDENT_NESTED_BASE + depth * ROW_INDENT_STEP : ROW_INDENT_TOP}px`;
}

/** Left offsets (px) of the guide lines a row at `depth` draws — one per level. */
export function guideOffsets(depth) {
  return Array.from({ length: depth }, (_, i) => GUIDE_FIRST + i * ROW_INDENT_STEP);
}

// Folders and top-level pages 16 px; sub-pages 14 px so they are not mistaken for folders.
export const ROW_ICON_SIZE = 16;
export const SUBPAGE_ICON_SIZE = 14;
export const ROW_CHEVRON_SIZE = 14;
export const ROW_ACTION_ICON_SIZE = 14;
